<div class="idp-error-info-content">
  <p [innerHTML]="errormsg" class="idp-error-info-content__msg"></p>
  <p [innerHTML]="errorinfo" class="idp-error-info-content__info"></p>
</div>
